import { gql } from '@apollo/client';

export const UPDATE_CLIENT_GROUP_PORTFOLIO = gql`
  mutation updateClientGroupPortfolio($input: UpdateClientGroupPortfolioInput!) {
    updateClientGroupPortfolio(input: $input) {
      clientGroup {
        id
      }
    }
  }
`;
